import React from "react";
import { InnerWrapper, OuterWrapper } from "../../wrapper/wrapper";
import InternshipData from "./popularInternships";
import {
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Box,
} from "@mui/material";
import PlayIcon from "../../../images/icons/play.svg";
import {
  ActionButton,
  CardBody,
  CardTitle,
  Title,
} from "./internships.components";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./internships.css";

function PopularInternships() {
  var settings = {
    dots: true,
    arrows: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1000,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
        },
      },
    ],
  };

  return (
    <OuterWrapper sx={{ background: "#E5E6ED", pt: "66px", pb: "104px" }}>
      <InnerWrapper>
        <Title sx={{ fontSize: { xs: 28, sm: "32px" }, px: { xs: "10px" } }}>
          Popular Internship Programs
        </Title>
        <Box component={Slider} {...settings} sx={{ px: { xs: "10px" } }}>
          {InternshipData.map((data) => {
            return (
              <CardBody
                sx={{ width: { sm: "265px !important" }, ml: { md: 2.5 } }}
              >
                <CardActionArea>
                  <CardMedia component="img" image={data.imgUrl} alt="" />
                  <CardContent sx={{ borderBottom: "0.5px solid #C4C4C4" }}>
                    <CardTitle>{data.title}</CardTitle>
                  </CardContent>
                </CardActionArea>
                <CardActions>
                  <ActionButton component={Link} to={data.url}>
                    <Box component="img" src={PlayIcon} alt="" sx={{ mr: 1 }} />
                    Self Placed
                  </ActionButton>
                </CardActions>
              </CardBody>
            );
          })}
        </Box>
      </InnerWrapper>
    </OuterWrapper>
  );
}

export default PopularInternships;
